import Http from '@/libs/axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    itemSelectOptions: []
  },
  getters: {
    items: state => {
      return state.items
    },
    itemSelectOptions: state => {
      return state.itemSelectOptions
    }
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      state.items = items
    },
    SET_ITEM(state, item){
      state.item = item
    },
    SET_SELECT_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((key, index) => {
        let value = items[key]
        return { value: value, text: `${value} - ${key}` }
      })

      state.itemSelectOptions = listOfObjects
    },
  },
  actions: {
    getList({commit}, {params}){
      return new Promise((resolve, reject) => {
        Http.get('pondok', { params: params }).then(response => {
            commit('SET_ITEM_LIST', response.data)
            resolve()
        }).catch(error => reject(error))
      })
    },

    show({ commit }, { id }){
      return new Promise((resolve, reject) => {
        Http:get(`pondok/${id}`).then(response => {
          commit('SET_ITEM', response.data)
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    create({ }, { payload } ){
      return new Promise((resolve, reject) => {
        Http.post('pondok', payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    update({ }, { payload } ){
      return new Promise((resolve, reject) => {
        Http.put(`pondok/${payload.PondokID}`, payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    destroy({ }, { id } ){
      return new Promise((resolve, reject) => {
        Http.delete(`pondok/${id}`).then(response => {
        resolve(response)
        }).catch(error => reject(error))
      })
    },
    getSelectOptions({commit, dispatch}){
      return new Promise((resolve, reject) => {
        Http.get('pondok/select-options').then(response => {
          commit('SET_SELECT_OPTIONS', response.data)
          resolve()
        }).catch(error => reject(error))
      })
    },
  },
}
